import { TextField } from "@material-ui/core";
import React from "react";
import { mask, unMask } from "remask";

export default ({ field, form, error, ...props }) => {
  return (
    <TextField
      {...props}
      {...field}
      fullWidth
      label="CPF/CNPJ do credor"
      inputProps={{ maxLength: 18 }}
      value={mask(unMask(field.value), [
        "999.999.999-99",
        "99.999.999/9999-99",
      ])}
      variant="standard"
    />
  );
};
